import styled from 'styled-components';

export const RewardHistoryContainerStyled = styled.div`
  padding: 0px 0px 125px 0px;
`;
